<template>
    <div>
        <CCargandoInformacion v-if="cargandoInformacion" :mostrarError="ocurrioError"></CCargandoInformacion>
        <div v-if="!cargandoInformacion">
            <div v-if="this.campoRequeridoEsValido(datosArea)" id="titulo-area">
                <h1>{{ (this.campoRequeridoEsValido(datosArea.titulo)) ? datosArea.titulo : 'Documentos' }}</h1>
                <h3>{{ datosArea.subtitulo }}</h3>
                <div class="hr-titulo"></div>
            </div>
            <CSeccion v-for="(seccion) in secciones" :key="'seccion-' + seccion.SeccionId" 
                class="espacio-entre-secciones"
                :informacion="{ idElemento: seccion.SeccionId, nombre: seccion.Nombre }"
                :formatosDeSeccion="[{ tipoDeFormato: seccion.FormatoId, contenidos: seccion.Contenidos }]"
                :opciones="{ tiposDocumentoArea: tiposDocumentosArea, tipoDeDocumentoSeleccionado: tipoDeDocumentoSeleccionado }"></CSeccion>
        </div>
    </div>
</template>
<script>
import router from '@/router/index'
import CSeccion from "@/components/Intranet/Comun/CSeccion.vue";
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import CCargandoInformacion from "@/components/Intranet/Comun/CCargandoInformacion";
import axios from 'axios'

export default {
    components: {
        CSeccion: CSeccion,
        CCargandoInformacion: CCargandoInformacion
    },
    beforeRouteEnter (to, from, next) {
        const VISTA_RAIZ = 'Inicio';
        next(async (instanciaVue) => {
            instanciaVue.cargandoInformacion = true;
            const PAGINA_HABILITADA = await Promise.resolve(instanciaVue.usuarioTieneLaPaginaHabilitada({ ruta: to.path }));
            if(!PAGINA_HABILITADA) {
                router.push({ name: VISTA_RAIZ});
                instanciaVue.cargandoInformacion = false;
                comun.mensajeDeAlerta('No tienes acceso a la pagina solicitada', null, null);
            }
        });
    },
    data() {
        return {
            secciones: [],
            datosArea: null,
            tiposDocumentosArea: [],
            cargandoInformacion: true,
            TIPOS_CONVERSION_CONTENIDOS: {
                /* NOTA: CREAR FUNCION PARA OBTENER LOS ENCABEZADOS Y AGREGAR VALIDACION EN FOR DE CONVERSION DE CONTENIDOS */
                // TIPO TEXTO
                23: ({ contenido, agregarATiposDocumento }) => {
                    const { ContenidoDeIntreanetId, TextoDelContenido } = contenido;
                    let contenidoObj = {};
                    contenidoObj.tipoId = ContenidoDeIntreanetId;
                    contenidoObj.nombre = TextoDelContenido;
                    contenidoObj.activo = true;
                    if(agregarATiposDocumento)
                        this.tiposDocumentosArea.push(contenidoObj);
                    else
                        return contenidoObj;
                },
                // ENLACES
                36: ({ contenido, agregarATiposDocumento }) => {
                    const { TextoDelVinculo, TextoDelContenido, Vinculo } = contenido;
                    let contenidoObj = {};
                    contenidoObj.Titulo = TextoDelVinculo;
                    contenidoObj.RutaParaAccesar = this.campoRequeridoEsValido(Vinculo) ? Vinculo : contenido.ArchivosDeContenidoIntranet[0].Ruta;
                    contenidoObj.Descripcion = TextoDelContenido;
                    contenidoObj.EsArchivo = this.campoRequeridoEsValido(Vinculo) ? false : true;
                    return contenidoObj;
                },
                // DOCUMENTOS
                37: ({ contenido, agregarATiposDocumento }) => {
                    const { FechaDeRegistro, TextoDelContenido, ContenidoAlQuePertenece, UsuarioQueRegistro } = contenido;
                    const { Ruta, NombreBase } = contenido.ArchivosDeContenidoIntranet[0];
                    let contenidoObj = {};
                    contenidoObj.Titulo = TextoDelContenido;
                    contenidoObj.RutaParaAccesar = Ruta;
                    contenidoObj.Archivo = NombreBase;
                    contenidoObj.Nombre = TextoDelContenido;
                    contenidoObj.Extension = NombreBase.split('.').pop().toUpperCase();
                    contenidoObj.Fecha = moment(FechaDeRegistro).format('YYYY-MM-DD');;
                    contenidoObj.Tipo = ContenidoAlQuePertenece.TextoDelContenido;
                    contenidoObj.InicialesUsuario = UsuarioQueRegistro.Nombre.charAt(0).toUpperCase() + UsuarioQueRegistro.ApellidoMaterno.charAt(0).toUpperCase();
                    contenidoObj.usuario = UsuarioQueRegistro.Nombre + ' ' +UsuarioQueRegistro.ApellidoMaterno;
                    contenidoObj.ContenidoAlQuePerteneceId = ContenidoAlQuePertenece.ContenidoDeIntreanetId;
                    return contenidoObj;
                }
            },
            tipoDeDocumentoSeleccionado: 'Todos',
            ocurrioError: false
        }
    },
    methods: {
        usuarioTieneLaPaginaHabilitada: async function({ ruta }) {
            let habilitada = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.VerificarSiTieneHabilitadaPagina;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDePagina: this.obtenerPrefijoBaseDeLaRuta({ rutaDeLaPaginaDeIntranet: ruta })
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, TieneHabilitadaLaPagina } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    habilitada = TieneHabilitadaLaPagina
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return habilitada;
        },
        // SECCION PARA FUNCIONES
        iniciarProcesoCargaDeInformacion: async function() { 
            try {
                this.cargandoInformacion = true;
                const CARGO_CONTENIDOS_SIN_ERROR = await Promise.resolve(this.obtenerPaginaConSeccionesYContenidosBD());
                this.cargandoInformacion = !(CARGO_CONTENIDOS_SIN_ERROR);
                this.ocurrioError = this.cargandoInformacion;
                console.log('formatos::',this.secciones);
                $('html, body').animate({ scrollTop:0 }, 'slow');
            }
            catch(excepcion) {
                console.log(excepcion);
            }
        },
        obtenerPaginaConSeccionesYContenidosBD: async function() {
            let procesoSinError = false;
            console.log('route::',this.$route)
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.ObtenerContenidosDeIntranetAdministracion;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDeLaPaginaDeIntranet: this.obtenerPrefijoBaseDeLaRuta({ rutaDeLaPaginaDeIntranet: this.$route.fullPath }), 
                    PorAreaDeUsuario: true,
                    EsPrueba: false 
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, PaginaDeIntranet } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    console.log('objPagina::',PaginaDeIntranet);
                    await Promise.resolve(this.convertirContenidosAObjetosDeFormatos({ pagina: PaginaDeIntranet }));
                    procesoSinError = true;
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return procesoSinError;
        },
        obtenerPrefijoBaseDeLaRuta: function({ rutaDeLaPaginaDeIntranet }) { 
            let rutaBase = rutaDeLaPaginaDeIntranet;
            let elementosRuta = rutaDeLaPaginaDeIntranet.split('/');
            if(this.campoRequeridoEsValido(elementosRuta)) {
                // 2 parametros a eliminar para obtener la ruta base
                elementosRuta.pop();
                elementosRuta.pop();
                rutaBase = elementosRuta.join('/');
            }
            return rutaBase;
        },
        convertirContenidosAObjetosDeFormatos: async function({ pagina }) {
            if(this.campoRequeridoEsValido(pagina)) {
                const { SeccionesDeIntranet } = pagina;
                if(this.campoRequeridoEsValido(SeccionesDeIntranet)) {
                    const SECCION_TIPOS_DE_DOCUMENTOS_ID = 28;
                    this.secciones = SeccionesDeIntranet.map(sBD => {
                        let seccionObj = {};
                        seccionObj.SeccionId = sBD.SeccionDeIntranetId;
                        seccionObj.Nombre = sBD.Nombre;
                        seccionObj.FormatoId = sBD.TipoFormato.TipoFormatoId;

                        if(this.campoRequeridoEsValido(sBD.SeccionesQueMePertenecen))
                            this.asignarEncabezadosDeArea({ secciones: sBD.SeccionesQueMePertenecen });
        
                        let contenidosDeSeccionObj = sBD.Contenidos.map((cBD) => {
                            let esTipoDeDocumento = (sBD.SeccionDeIntranetId == SECCION_TIPOS_DE_DOCUMENTOS_ID);
                            let contenidoObj = this.TIPOS_CONVERSION_CONTENIDOS[sBD.TipoFormato.TipoFormatoId]({ contenido: cBD, agregarATiposDocumento: esTipoDeDocumento });
                            return contenidoObj;
                        });
                        seccionObj.Contenidos = contenidosDeSeccionObj;
                        return seccionObj;
                    });
                    this.tiposDocumentosArea.push({ tipoId: -1, nombre: 'Todos', activo: true });
                }
            }
        },
        asignarEncabezadosDeArea: function({ secciones }) { debugger
            const SECCION_TITULO_ID = 36;
            const SECCION_SUBTITULO_ID = 37;
            this.datosArea = {};
            secciones.forEach(s => {
                if(s.SeccionDeIntranetId == SECCION_TITULO_ID)
                    this.datosArea.titulo = (this.campoRequeridoEsValido(s.Contenidos)) ? s.Contenidos[0].TextoDelContenido : '';
                else if(s.SeccionDeIntranetId == SECCION_SUBTITULO_ID)
                    this.datosArea.subtitulo = (this.campoRequeridoEsValido(s.Contenidos)) ? s.Contenidos[0].TextoDelContenido : '';
            });
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        /* obtenerNombreDeArea: function({ area }) { 
            if(this.campoRequeridoEsValido(area.datosArea)) 
                this.datosArea = area.datosArea
            else {
                const URL = router.history.current.fullPath;
                const SECCIONES_URL = URL.split('/');
                if(SECCIONES_URL.length > 0) {
                    const NOMBRE_AREA = SECCIONES_URL[SECCIONES_URL.length - 1];
                    this.datosArea = { titulo: NOMBRE_AREA };
                }
            }
        }, */
        obtenerTiposDeDocumentoArea: function() {
            this.tiposDocumentosArea = [
                { tipoId: 1, nombre: 'Notas', activo: true },
                { tipoId: 2, nombre: 'Protocolos', activo: false },
                { tipoId: 3, nombre: 'Universidad', activo: false },
                { tipoId: 4, nombre: 'Direccion de administracion de personal', activo: false }
            ]
        }
    },
    async created() {
        //const PARAMETROS_VISTA = router.history.current.params;
        this.tipoDeDocumentoSeleccionado = router.history.current.params.tipoDocumento;
        await Promise.resolve(this.iniciarProcesoCargaDeInformacion());
        /* const PARAMETROS_VISTA = router.history.current.params; */
        /* this.obtenerNombreDeArea({ area: PARAMETROS_VISTA }); */
         /* buscar en bd las secciones del area
        this.secciones = [
            { SeccionId: 3, Nombre: 'Contenedor Enlaces', FormatoId: 36, Contenidos: [
                { Titulo: 'Clínica Procesal Civil 2013', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1' },
                { Titulo: 'Clínica Procesal Civil 2014', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1' },
                { Titulo: 'Clínica Procesal Civil 2015', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1' },
                { Titulo: 'Clínica Procesal Civil 2016', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1' },
                { Titulo: 'Clínica Procesal Civil 2017', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1' },
                { Titulo: 'Clínica Procesal Civil 2018', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1' }
            ] },
            { SeccionId: 4, Nombre: 'Documentos de area', FormatoId: 37, Contenidos: [
                { Titulo: 'Clínica Procesal Civil 2013', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Nota_Prueba_IP_1', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2014', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Nota_Prueba_IP_1', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2015', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Nota_Prueba_IP_1', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2016', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Nota_Prueba_IP_1', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2017', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Nota_Prueba_IP_1', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' },
                { Titulo: 'Clínica Procesal Civil 2018', RutaParaAccesar: '/Intranet/Inicio', Descripcion: 'enlace 1', Nombre: 'Nota_Prueba_IP_1', Extension: 'PDF', Mb: '120', Fecha: '01/01/0001', Tipo: 'Nota' }
            ] }
        ];

        this.obtenerTiposDeDocumentoArea(); */
    },
    computed: {
        obtenrUrlArea() {
            return this.$route.path;
        }
    },
    watch: {
        '$store.state.Login_PermisosDelSistema': function() {
            console.log('permisos::',this.$store.state.Login_PermisosDelSistema);
        }
    }
}
</script>
<style scoped>
#titulo-area {
    padding: 7vmin 16vmin 0vmin 16vmin;
}

#titulo-area h1 {
    font-size: 5vmin;
    font-weight: bold;
    color: #000000;
    margin-bottom: -0.1em;
}

#titulo-area h3 {
    font-size: 2.5vmin;
    color: #8d8d8d;
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#be9a5e;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Areas/CDocumentos.vue